import { useCallback, useState } from 'react';

import { hooks } from '@febos-io/common';
import { findDocumentList } from '../config';
import { ExamI } from '../types';

export function useDocumentListCallback(type, limit: number, sort = undefined) {
  const [elements, setElements] = useState<ExamI[]>([]);
  const [meta, setMeta] = useState({ total: 0, pages: 0 });

  const { callback, loading } = hooks.useRequestCallback(
    useCallback(
      async (request, filter, page) => {
        const {
          documentos = [],
          total,
          totalPages,
          totalPaginas,
          totalElementos
        } = await request.exec(findDocumentList(type, page, limit, sort, filter));
        setElements(documentos);
        setMeta({ total: total || totalElementos, pages: totalPages || totalPaginas });
      },
      [type, limit, sort]
    )
  );

  return {
    loading,
    elements,
    meta,
    callback
  };
}

export default useDocumentListCallback;
